import React from 'react';
import { Provider } from 'react-redux';
import './styles/main.scss';
import './styles/overide-defaluts.scss';
import { RouteRoot } from '../app/routes/route.root';


const checkAndSetTitle = () => {
  if (global.operatorName) {
    document.title = `${global.operatorName} - Agent Portal`;
  } else {
    setTimeout(checkAndSetTitle, 100); // retry until it's defined
  }
};

export const mountApp = (store = {}) => {

  checkAndSetTitle();

    return(
      <div className="root-div">
          <Provider store={store}>
              {/* <BrowserRouter> */}
                {/* <AppHeader /> */}
                <RouteRoot />
                {/* <DeviceProvider> */}
                    {/* {renderRoutes(routes)} */}
                {/* </DeviceProvider> */}
              {/* </BrowserRouter> */}
          </Provider>
      </div>
    );
}